"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => {
  const lineHeight = 22;
  return {
    contentEdit: {
      // TODO - fix styles when use in TextField (lineHeight, minHeight, verticalAlign ...)
      width: '100%',
      border: 'none',
      outline: 'none',
      boxSizing: 'border-box',
      overflow: 'auto',
      maxHeight: props => props.rows * lineHeight,
      minHeight: 19,
      whiteSpace: 'pre-wrap',
      display: 'inline-block',
      lineHeight: `${lineHeight}px`,
      // Use the lineHeight variable
      counterReset: 'line',
      '&:empty:after': {
        content: 'attr(placeholder)',
        display: 'block',
        color: theme.textField.placeholder
      },
      '&.lineNumbers': {
        '&:empty': {
          '&:before': {
            height: 22
          }
        },
        '& > div, &:empty': {
          position: 'relative',
          paddingLeft: 48,
          '&:before': {
            counterIncrement: 'line',
            content: 'counter(line)',
            width: 24,
            display: 'inline-block',
            borderRight: '1px solid #ddd',
            paddingLeft: 8,
            color: '#888888',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0
          }
        }
      }
    }
  };
};

exports.default = _default;